export default {
  agreed: 'Einverstanden',
  searchStatement: 'Nutzungsbedingungen suchen',
  noData: 'Keine weiteren Daten',
  starts: 'Sterne',
  searching: 'Suche...',
  searchService: 'Nutzungsbedingungen suchen',
  filter: {
    performanceQuality: 'Leistungsqualität',
    comprehensiveExperienceScore: 'Umfassende Bewertung der Erfahrung',
    fourStartDown: 'Unter vier Sternen',
    certifiedFactory: 'Zertifizierte Fabrik',
    dayYield: 'Produktionsrate innerhalb von 24 Stunden',
    doubleDayYield: 'Produktionsrate innerhalb von 48 Stunden',
    performanceGuarantee: 'Leistungsgarantie',
    dayShipments: 'Versand am selben Tag',
    strictSelect: 'Strenge Auswahl',
    disStrictSelect: 'Strenge Auswahl des Vertriebs',
    dayShip: 'Lieferung innerhalb von 24 Stunden',
    doubleDayShip: 'Lieferung innerhalb von 48 Stunden',
    sevenDayNoReason: 'Sieben Tage ohne Angabe von Gründen',
    oneIssuing: 'Unterstützt Einzelstückversand',
    onePostIssuing: 'Unterstützt kostenlosen Versand (Einzelstückversand ist kostenlos)',
    sevenDayNew: '7 Tage für neue Produkte',
    thirtyDayNew: '30 Tage für neue Produkte',
    wordStrictSelect: 'Globale strenge Auswahl',
    isSelect: 'Grenzüberschreitende Auswahl von Paletten',
    priceSort: 'Preisranking',
    compositeSort: 'Umfassendes Ranking',
    up: 'Einklappen',
    reset: 'Zurücksetzen',
    moreFilters: 'Weitere Filterkriterien',
    bestMatch: 'Beste Übereinstimmung',
    saleHighToLow: 'Verkäufe: Hoch nach Niedrig',
    saleLowToHigh: 'Verkäufe: Niedrig nach Hoch',
    priceHighToLow: 'Preis: Hoch nach Niedrig',
    priceLowToHigh: 'Preis: Niedrig nach Hoch',
    fastToSlow: 'Versandzeit: Schnell nach Langsam',
    slowToFast: 'Versandzeit: Langsam nach Schnell',
  },
}
